import { createSlice } from '@reduxjs/toolkit';

const navbarSlice = createSlice({
  name: 'navbar',
  initialState: {
    open: false,
    mobileOpen: false,
    forceMobile: true,
  },
  reducers: {
    navbarToggleFolded: (state, action) => {
      state.foldedOpen = !state.foldedOpen;
    },
    navbarOpenFolded: (state, action) => {
      state.foldedOpen = true;
    },
    navbarCloseFolded: (state, action) => {
      state.foldedOpen = false;
    },
    navbarToggleMobile: (state, action) => {
      state.mobileOpen = !state.mobileOpen;
    },
    navbarOpenMobile: (state, action) => {
      state.mobileOpen = true;
    },
    navbarCloseMobile: (state, action) => {
      state.mobileOpen = false;
    },
    navbarClose: (state, action) => {
      if (state.forceMobile) state.mobileOpen = false;
      else state.open = false;
    },
    navbarOpen: (state, action) => {
      if (state.forceMobile) state.mobileOpen = true;
      else state.open = true;
    },
    navbarToggle: (state, action) => {
      if (state.forceMobile) state.mobileOpen = !state.mobileOpen;
      else state.open = !state.open;
    },
    setForceMobile: (state, action) => {
      state.forceMobile= action.payload;
    },
  },
});

export const {
  navbarToggleFolded,
  navbarOpenFolded,
  navbarCloseFolded,
  navbarOpen,
  navbarClose,
  navbarToggle,
  navbarOpenMobile,
  navbarCloseMobile,
  navbarToggleMobile,
} = navbarSlice.actions;

export const selectFuseNavbar = ({ fuse }) => fuse.navbar;
export const selectNavbarOpen = ({ fuse }) => fuse.navbar.open;
export const selectNavbarMobileOpen = ({ fuse }) => fuse.navbar.mobileOpen;

export default navbarSlice.reducer;
